import React from "react";
import { createRoot } from "react-dom/client";

import { initIntercom } from "../utils/intercom";
import { initLogrocket } from "../utils/logrocket";
import { registerServiceWorker } from "../utils/registerServiceWorker";
import { initSentry } from "../utils/sentry";
import Main from "./Main";

initSentry();
initLogrocket();
initIntercom();
registerServiceWorker();

const container = document.getElementById("root") as Element;

const root = createRoot(container);

root.render(<Main />);
